import React from "react";
import DeltaTable from "Components/Common/DeltaTable"
import ProductDeltaHeader from "Components/GMS/Products/ProductList/ProductDeltaHeader"
import { PRODUCT_TABLE_OPTIONS, PRODUCT_TYPE_CHILD, PRODUCT_TYPE_PARENT, PRODUCT_TYPE_PRODUCT, accordianTableHeader, tableHeader } from "./constants"
import { TFetchData } from "types/Components/Common/DeltaTable";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { TTableHeader } from "types/Components/Common/Table/Table";
import { TChildSelected, TEditParent, TParent, TParentSelected, TProduct, TProductDeltaData, TProductSelected } from "types/Pages/ProductDelta";
import { TFilters } from "types/hooks/useTable";
import { listProductsByCategoryId } from "api/Products";
import Utils from "Common/Utils";
import CreateEditParentDialog from "Components/GMS/Products/ProductList/CreateEditParentDialog";
import { ProductsContext, ProductsContextType } from "Components/GMS/Products/ProductsContext";
import { toast } from "react-toastify";
import { updateParent } from "api/Parent";
import { getCategoryById } from "api/Category";
import AccordionTable from "./AccordionTable";

const ProductDeltaList = (props: any) => {
    const {
        setSelected_Category,
        editParent,
        setEditParent,
        setRemoveChildModal,
        setDeleteParent,
        categoryData,
        getCategoryTypeAndCategory,
        setPageSize,
        filters,
        setFilters
    } = useContext(ProductsContext) as ProductsContextType

    const [productSelected, setProductSelected] = useState<TProductSelected>([])
    const [parentSelected, setParentSelected] = useState<TParentSelected>([])
    const [childSelected, setChildSelected] = useState<TChildSelected>([])
    const [moveToParentModal, setMoveToParentModal] = useState<boolean>(false);
    
    const [loading, setLoading] = useState<boolean>(false)
    const isInitialLoading = useRef<boolean>(true)
    const [createParentModal, setCreateParentModal] = useState<boolean>(false);

    const [data, setData] = useState<TProductDeltaData | null>(null)

    const { params } = props.match;
    const { categoryid } = params;

    const resetSelections = () => {
        setParentSelected([])
        setChildSelected([])
        setProductSelected([])
    }

    // if category not selected
    useEffect(() => {
        resetSelections()
        if (categoryData?.length === 0) getCategoryTypeAndCategory()
        getCategoryById(categoryid)
            .then((res) => {
                setSelected_Category(res as any)
            })
            .catch((err) => console.error(err))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryid]);

    const fetchData: TFetchData = useCallback(() => {
        listProductsByCategoryId(categoryid, filters)
            .then((result) => {
                setData(result?.data)
            })
            .catch(err => {
                toast.error(err.message)
            })
            .finally(() => {
                isInitialLoading.current = false
                setLoading(false)
            })
    }, [filters, categoryid])

    const handleSearchChange = (searchTerm: string) => {
        setFilters((prev) => ({
            ...prev,
            search: searchTerm
        }))
    }

    useEffect(() => {
        if (!categoryid) return
        let cancel = false

        setLoading(true)

        listProductsByCategoryId(categoryid, filters)
            .then((result) => {
                if (!cancel)
                    setData(result?.data)
            })
            .catch(err => {
                if (!cancel) toast.error(err.message)
            })
            .finally(() => {
                if (!cancel) {
                    isInitialLoading.current = false
                    setLoading(false)
                }
            })

        return () => { cancel = true }
    }, [filters, categoryid])

    useEffect(() => {
        isInitialLoading.current = true
    }, [categoryid])

    const updateFilters = (filters: TFilters) => {
        setPageSize(filters.limit as number ?? null)

        setFilters(prev => ({
            ...prev,
            ...filters,
        }))
    }

    const handleSearch = () => {
        setLoading(true)
        fetchData()
    }

    const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, deltaItem: any) => {
        e.persist()
        const item = Utils.getDeltaValue(deltaItem)
        if (item?.product_type === PRODUCT_TYPE_PARENT) {
            const checked = isSelectedCondition(deltaItem)
            setParentSelected(prev => {
                if (checked === -1) return [...prev, item]
                const next = [...prev]
                const index = next.findIndex((i: any) => i.id === item.id)
                next.splice(index, 1)
                return next
            })

            deltaItem.items &&
                setChildSelected(prev => {
                    let _childSelected: TProduct[] = []
                    if (checked === -1) {
                        deltaItem.items?.map((it: any) => {
                            const t = Utils.getDeltaValue(it)
                            _childSelected.push(t)
                            return true;
                        })
                        return [...prev, ..._childSelected]
                    }
                    const next = [...prev]

                    deltaItem.items?.map((it: any) => {
                        //const t = getDeltaValue(it)
                        const index = next.findIndex((i: any) => i.id === it.id)
                        next.splice(index, 1)
                        return true;
                    })

                    return next
                })

            if (checked === -1) item.items?.map((it: any) => {
                const t = Utils.getDeltaValue(it)
                setChildSelected(prev => {
                    return [...prev, t]
                })
                return true;
            })
        }

        if (deltaItem?.type === PRODUCT_TYPE_PRODUCT)
            setProductSelected(prev => {
                if (e?.target?.checked) return [...prev, item]
                const next = [...prev]
                const index = next?.findIndex((i: any) => i.id === item.id)
                next?.splice(index, 1)
                return next
            })
        if (deltaItem?.type === PRODUCT_TYPE_CHILD) {
            setChildSelected(prev => {
                if (e.target.checked) return [...prev, item]
                const next = [...prev]
                const index = next.findIndex((i: any) => i.id === item.id)
                next.splice(index, 1)
                return next
            })
        }
    }

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>, rows?: any) => {
        let _parentSelected: TParent[] = []
        let _productSelected: TProduct[] = []
        let _childSelected: TProduct[] = []
        if (!e.target.checked || selectedAllCondition() === 0 || rows.length === 0) {
            resetSelections()
            return
        }

        rows.map((row: any) => {
            const item: any = Utils.getDeltaValue(row)
            if (item?.product_type === PRODUCT_TYPE_PARENT)
                _parentSelected.push(item)
            else
                _productSelected.push(item)

            row.items?.map((it: any) => {
                const t = Utils.getDeltaValue(it)
                _childSelected.push(t)
                return true;
            })
            return true;
        })
        setProductSelected(_productSelected)
        setParentSelected(_parentSelected)
        setChildSelected(_childSelected)
    }

    const selectedAllCondition = (rows?: any) => {
        if (((data?.products?.length && data?.products?.length > 0) &&
            data?.products?.every((item: any) => {
                return ((
                    productSelected.findIndex((i: any) => i.id === item.id) !== -1 ||
                    parentSelected.findIndex((i: any) => i.id === item.id) !== -1) &&
                    (!item.items || item.items?.every((it: any) => {
                        return childSelected.findIndex((i: any) => i.id === it.id) !== -1
                    })))
            }))) return 1
        if (productSelected.length > 0 || parentSelected.length > 0 || childSelected.length > 0) return 0
        return -1
    }

    const isSelectedCondition = (row: any) => {
        const item = Utils.getDeltaValue(row)

        if (item?.product_type === PRODUCT_TYPE_PARENT && (parentSelected.findIndex((i: any) => i.id === item.id) !== -1 ||
            (!row.items || (row.items?.length > 0 && row.items?.every((prod: any) => {
                return childSelected.findIndex((i: any) => i.id === prod.id) !== -1
            }))))
        ) return 1
        if (productSelected.findIndex((i: any) => i.id === item.id) !== -1 || childSelected.findIndex((i: any) => i.id === item.id) !== -1) return 1
        if (row.items?.length > 0 && row.items.some((prod: any) => childSelected.findIndex((i: any) => i.id === prod.id) !== -1)) return 0
        return -1
    }

    const handleParentEdit = (name: string, disabledAttributes: string[]) => {
        if (!editParent?.id) return

        updateParent(editParent.id, name, disabledAttributes)
            .then(res => {
                toast.success(res?.message)
                setEditParent(null)
                fetchData()
                resetSelections()
            })
            .catch((err) => toast.error(err.message))
    }

    const editParentFn = (item: TEditParent) => {
        setEditParent(item)
    }

    const deleteParentFn = (item: TEditParent) => {
        setDeleteParent(item)
    }

    const dropdownOptions = (item: any) => {

        // disable menu if any product is selected
        if (!productSelected || productSelected?.length > 0) return []

        if (item?.type === PRODUCT_TYPE_PARENT)
            return [
                {
                    label: 'Edit',
                    callbackFunction: () => editParentFn(item)
                },
                {
                    label: 'Delete',
                    callbackFunction: () => deleteParentFn(item),
                }
            ]

        return [];
    }

    const attrs = Utils.generateHeadersFromArray(data?.columns ?? [])

    const accordionHeaders: TTableHeader[] | null = data?.columns ? [...accordianTableHeader, ...attrs] : null

    const tableOptions = {
        ...PRODUCT_TABLE_OPTIONS,
        dropDownCallback: dropdownOptions,
        accordion: {
            component: (item: any) => <AccordionTable
                item={item}
                columns={accordionHeaders}
                handleSelectAll={handleSelectAll}
                isSelectedCondition={isSelectedCondition}
                selectedAllCondition={selectedAllCondition}
                handleSelect={handleSelect}
                setChildSelected={setChildSelected}
                setMoveToParentModal={setMoveToParentModal}
                setRemoveChildModal={setRemoveChildModal}
            />,
            condition: (item: any) => (item?.product_type === PRODUCT_TYPE_PARENT),
        },
    }


    return (
        <div className={`tw-max-w-full tw-relative`}>
            <div className={`tw-z-[1040] tw-relative`}>
                <ProductDeltaHeader
                    totalProducts={data?.product_count}
                    dataLoading={loading}
                    setDataLoading={setLoading}
                    handleSearchChange={handleSearchChange}
                    handleSearch={handleSearch}
                    categoryid={categoryid}
                    filters={filters}
                    setFilters={setFilters}
                    updateFilters={updateFilters}
                    productSelected={productSelected}
                    childSelected={childSelected}
                    setChildSelected={setChildSelected}
                    setProductSelected={setProductSelected}
                    fetchData={fetchData}
                    moveToParentModal={moveToParentModal}
                    setMoveToParentModal={setMoveToParentModal}
                    createParentModal={createParentModal}
                    setCreateParentModal={setCreateParentModal}
                />
            </div>
            <div className="tw-py-3">
                <DeltaTable
                    columns={data?.columns ? [...tableHeader, ...attrs] : null}
                    loading={(loading && isInitialLoading.current)}
                    dataLoading={loading}
                    isSelectedCondition={isSelectedCondition}
                    selectedAllCondition={selectedAllCondition}
                    handleSelectAll={handleSelectAll}
                    totalRecords={data?.parent_child_count}
                    data={data?.products}
                    handleSelect={handleSelect}
                    pageSize={filters?.limit}
                    updateFilters={updateFilters}
                    filters={filters}
                    // bgColors=[""]
                    className={`tw-rounded-md`}
                    dataCallback={Utils.getDeltaValue}
                    options={tableOptions}
                />
            </div>

            <CreateEditParentDialog
                isOpen={!!editParent}
                heading="Edit Parent"
                onClose={() => {
                    setEditParent(null)
                }}
                handleSubmit={handleParentEdit}
                buttonLabel="Edit"
            />
        </div>
    )
}

export default ProductDeltaList;